let _offscreenCanvas = null;
let _offscreenCtx = null;
let _referImg = {};
const FJCanvasUtil = {
    /**
     * @desc 绘制格子色背景
     * @param {*} ctx
     * @param {*} width
     * @param {*} height
     */
    drawTransparentBackground: (ctx, width, height, size = 6) => {
        ctx.save();
        for (let y = 0; y < height; y += size) {
            for (let x = 0; x < width; x += size) {
                ctx.fillStyle = (x / size + y / size) % 2 === 0 ? '#ffffff' : '#cccccc';
                ctx.fillRect(x, y, size, size);
            }
        }
        ctx.restore();
    },
    createShader: (gl, type, source) => {
        const shader = gl.createShader(type);
        if (!shader) {
            throw new Error('Create shader fail!');
        }
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        const success = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
        if (success) {
            return shader;
        }

        console.error(gl.getShaderInfoLog(shader));
        gl.deleteShader(shader);
    },
    createTexture: gl => {
        const texture = gl.createTexture();
        if (!texture) {
            throw new Error('Create texture fail!');
        }
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, texture);

        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

        gl.bindTexture(gl.TEXTURE_2D, null);

        return texture;
    },
    fitSize: (innerSize, outerSize, float = true) => {
        let r1 = innerSize.width / innerSize.height;
        let r2 = outerSize.width / outerSize.height;
        let w, h;
        if (r1 >= r2) {
            w = outerSize.width;
            h = w / r1;
        } else {
            h = outerSize.height;
            w = h * r1;
        }
        if (float) {
            return { width: w, height: h };
        } else {
            return { width: Math.floor(w), height: Math.floor(h) };
        }
    },
    couldOptFrame() {
        return typeof createImageBitmap !== 'undefined' && typeof OffscreenCanvas !== 'undefined';
    },
    getImageBitmap(canvas) {
        const width = canvas.width;
        const height = canvas.height;
        _offscreenCanvas = _offscreenCanvas || new OffscreenCanvas(width, height);

        if (_offscreenCanvas.width !== width) {
            _offscreenCanvas.width = width;
        }
        if (_offscreenCanvas.height !== height) {
            _offscreenCanvas.height = height;
        }
        _offscreenCtx = _offscreenCtx || _offscreenCanvas.getContext('2d');
        if (_offscreenCtx) {
            _offscreenCtx.drawImage(canvas, 0, 0, width, height);
            return _offscreenCanvas.transferToImageBitmap();
        }
        return null;
    },
    /**
     * 将图片文件按固定比例缩放
     * @param {File} file - 原始图片文件
     * @param {number} width - 最大宽度
     * @param {number} height - 最大高度
     * @param {string} [outputFormat='image/jpeg'] - 输出格式，可选 'image/jpeg' 或 'image/png'
     * @param {number} [quality=0.92] - 图片质量，0-1之间，仅对jpeg有效
     * @returns {Promise<Blob>} - 缩放后的图片Blob对象
     */
    resizeImage(file, width, height, outputFormat = 'image/jpeg', quality = 0.92) {
        return new Promise((resolve, reject) => {
            // 检查文件是否为图片
            if (!file.type.match('image.*')) {
                reject(new Error('请选择图片文件'));
                return;
            }

            const reader = new FileReader();

            // 读取文件
            reader.onload = event => {
                const img = new Image();

                img.onload = () => {
                    // 创建画布并绘制缩放后的图片
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;

                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);

                    // 将画布内容转换为Blob
                    canvas.toBlob(
                        blob => {
                            if (blob) {
                                resolve(blob);
                            } else {
                                reject(new Error('图片转换失败'));
                            }
                        },
                        outputFormat,
                        quality,
                    );
                };

                img.onerror = err => reject(new Error('图片加载失败: ' + err.message));

                // 加载图片
                img.src = event.target.result;
            };

            reader.onerror = err => reject(new Error('文件读取失败: ' + err.message));

            // 开始读取文件
            reader.readAsDataURL(file);
        });
    },
};

export default FJCanvasUtil;
